var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn an-open-note",attrs:{"tag":"button","to":{ query: Object.assign({}, _vm.$route.query), hash: 'notiz' },"replace":""}})}
var staticRenderFns = []

export { render, staticRenderFns }